<template>
    <v-dialog
        persistent
        v-model="isApplicationDialogOpen"
        content-class="custom-dialog"
        transition="dialog-bottom-transition"
        max-width="100%"
    >
      <v-card>
        <ValidationObserver v-slot="{ invalid, errors }" ref="validform">
          <form @submit.prevent="submit()" class="t-c">
            <div class="d-flex toolbar">
              <v-toolbar-title>마케팅론 신청하기</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn color="darken-1" text @click="closeDialog">
                  <img src="../../../assets/images/todaystore/btn-close.svg"/>
              </v-btn>
              </v-toolbar-items>
            </div>
            <v-row class="name" no-gutters>
              <v-col cols="3" class="t-l">
                <span class="field-title">이름</span> <span class="must-mark">*</span>
              </v-col>
              <v-col cols="9">
                <FormInput
                  type="text"
                  name="name"
                  v-model="name"
                  rules="required|name"
                  ref="name"
                  placeholder="이름을 입력해주세요."
                />
              </v-col>
              <v-col cols="9">
                <p
                  v-if="errors.number_of_table != null && errors.number_of_table[0] != null"
                  class="error-text t-l"
                >{{ errors.number_of_table[0] }}</p>
              </v-col>
            </v-row>
            <v-row class="mb-4 phone" no-gutters>
              <v-col cols="3" class="t-l">
                <span class="field-title">휴대폰</span> <span class="must-mark">*</span>
              </v-col>
              <v-col cols="9">
                <FormInput
                  type="tel"
                  name="phone"
                  v-model="phone"
                  @input="inputPhoneNum()"
                  rules="required|numeric|phone"
                  placeholder="휴대폰번호를 입력해주세요."
                />
              </v-col>
              <v-col cols="9">
                <p
                  v-if="errors.phone != null && errors.phone[0] != null"
                  class="error-text t-l"
                >{{ errors.phone[0] }}</p>
              </v-col>
            </v-row>
            <div class="agreements">
              <!--List-->
              <AgreementList class="list"
                              :agreements="terms"
                              v-if="terms && terms.length>=1">
              </AgreementList>
            </div>
            <v-btn
              v-ripple
              type="submit"
              :disabled="invalid"
              :class="{'active':!invalid}"
              class="confirm-btn"
            >
              신청 완료하기
            </v-btn>
          </form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
</template>
<script>
import FormInput from '@/components/form/FormInput'
import marketingApplicationApi from '@/api/marketing/applicationApi'
import AgreementList from './AgreementList'

export default {
  name: 'ApplicationDialog',
  components: {
    FormInput,
    AgreementList
  },
  props: ['isApplicationDialogOpen', 'userData'],
  data() {
    return {
      name: '',
      phone: '',
      connect_service: '마케팅론',
      utm_source: '',
      utm_medium: '',
      utm_campaign: '',
      terms: [
        {
          title: '서비스 이용약관',
          is_required: true,
          is_agreed: false,
          content: '' +
                    '<p>(주)펀다 귀중<br />귀사와의 금융거래와 관련하여 귀사가 본인의 개인(신용)정보를 수집·이용하고자 하는 경우에는 「개인정보보호법」 및 「신용정보의 이용 및 보호에 관한 법률」등에 따라 본인의 동의가 필요합니다. 본인은 귀사가 아래와 같이 본인의 개인(신용)정보를 수집·이용하는 것에 동의합니다.</p>' +
                    '<p><strong data-renderer-mark="true">①개인(신용)정보의 수집·이용 목적</strong><br />대출계약의 체결·이행·유지·관리,신용평가모형개발 등 통계작성, 신용질서문란행위 조사, 법령상 의무이행, 분쟁처리, 민원처리, 본인여부확인 등<br /><strong data-renderer-mark="true">②수집·이용할 개인(신용)정보의 항목</strong><br />개인식별정보 : 성명, 주민등록번호, 사업자번호, 주민등록증(운전면허증) 발급일, 연락처, 주소(자택,직장), E-mail, 본인인증정보, 직장정보, 성별, 국적, 운전면허정보, 여권번호, 외국인등록번호 등<br />신용거래정보 : 대출, 보증, 담보제공, 당좌거래, 신용카드, 할부금융, 시설대여와 금융거래 등 상거래와 관련하여 그 거래의 종류, 기간, 금액 및 한도 등에 관한 사항<br />신용도정보 : 연체, 부도, 대위변제, 대지급, 신용질서 문란행위와 관련된 금액 및 발생˙해소의 시기 등에 관한 사항<br />신용능력정보 : 재산, 채무, 소득의 총액, 납세실적 등 신용거래능력을 판단할 수 있는 정보<br />공공기관정보 : 개인회생, 파산, 면책 등에 관한 신청 및 법원의 결정 관련정보, 채무불이행자명부 등재˙말소 결정, 체납정보, 주민등록관련정보, 사회보험료˙공공요금˙수수료 관련 정보 등<br />신용관련정보 : 신용등급, 신용평점, 신용평가모형, 개인회생관련정보, 신용조회기록 등 기타 계약의 체결·이행·유지·관리 등과 관련하여 본인이 제공한 정보<br /><strong data-renderer-mark="true">③개인(신용)정보의 보유 및 이용기간</strong><br />위 개인(신용)정보는 금융거래 종료일로부터 5년까지 보유·이용됩니다.<br />금융거래 종료일 후에는 분쟁해결,민원처리,법령상 의무이행 및 당사 리스크 관리 업무만을 위하여 보유·이용됩니다.</p>' +
                    '<p><br />※귀하는 개인(신용)정보 수집·이용 동의를 거부할 권리가 있으나, 위 정보는 서비스 제공에 필수적으로 필요한 정보이므로 동의하지 않는 경우에는 계약의 체결˙이행˙유지˙관리 등이 불가능할 수 있음을 알려드립니다.</p>',
          uuid: 'dfsdfsdfsdf',
          code: 'SERVICE2323'
        },
        {
          title: '개인정보 제3자 제공 동의',
          is_required: true,
          is_agreed: false,
          content: '' +
            '<p>&nbsp;</p>' +
            '<p>(주)펀다 귀중</p>' +
            '<p>귀사와의 금융거래와 관련하여 귀사가 본인의 개인(신용)정보를 제공하고자 하는 경우에는 「개인정보보호법」 및 「신용정보의 이용 및 보호에 관한 법률」에 따라 본인의 동의가 필요합니다.본인은 귀사가 아래와 같이 본인의 개인(신용)정보를 제공하는 것에 동의합니다.</p>' +
            '<p>&nbsp;</p>' +
            '<p><strong data-renderer-mark="true">① 개인정보를 제공받는 자 <br/>-테이스티홀딩스 주식회사</strong></p>' +
            '<p>② 개인정보를 제공받는 자의 개인정보 이용 목적 <br/>-마케팅서비스 진행 확정 시, 마케팅 서비스 제공</p>' +
            '<p>③ 제공하는 개인정보의 항목 <br/>- 이름, 휴대폰번호, 상호명, 사업자정보</p>' +
            '<p>④ 개인정보를 제공받는 자의 개인정보 보유 및 이용 기간 <br/>-개인(신용)정보를 제공받는 자의 이용 목적 달성 시 까지</p>' +
            '<p>⑤ 마케팅서비스 이용에 동의를 거부할 경우 제공되지 않습니다.</p>',
          uuid: 'dfsdfsdfsdf',
          code: 'SERVICE2323'
        },
      ],
    }
  },
  mounted() {
    this.focusInput()
  },
  created() {
  },
  computed: {
    isCompleteAgreements() { // 동의 완료 여부
      let terms = this._.filter(this.terms, 'is_required')
      let isAgreedAll = this._.every(terms, 'is_agreed')

      return terms.length > 0 && isAgreedAll
    },

  },
  methods: {
    isComplete() { // 전체 완료 여부
      return this.isCompleteAgreements
    },
    focusInput() {
      this.$refs.name.$el.focus()
    },
    inputPhoneNum() {
      let phone = this.phone
      if (phone != null && phone.length > 0) {
        this.phone = phone.replace(/[^\d]/g, '')
      }
    },
    closeDialog() {
      this.$emit('close-application-dialog', false)
    },
    async submit() {
      if (!this.isComplete()) {
        this.$swal.fire({
          html: '모두 동의를 해야 합니다.',
          confirmButtonText: '확인'
        })
        return
      }
      try {
        const formData = new FormData()
        formData.append('phone', this.phone)
        formData.append('name', this.name)
        // formData.append('connect_service', this.connect_service)
        // formData.append('utm_source', this.utm_source)
        // formData.append('utm_medium', this.utm_medium)
        // formData.append('utm_campaign', this.utm_campaign)
        console.log('formData', formData)
        let { data: resp } = await marketingApplicationApi.postApplication(formData)
        console.log('resp', resp)

        if (resp && resp.is_duplicate_application) {
          await this.$swal.fire({
            html: '<b>신청된 내역이 존재합니다.</b><br/><br/>전문 상담사가 1영업일 이내<br/>연락드릴게요. 😊',
            confirmButtonText: '확인'
          })
        } else {
          await this.$swal.fire({
            html: '<b>신청이 완료되었습니다.</b><br/><br/>전문 상담사가 1영업일 이내<br/>연락드릴게요. 😊',
            confirmButtonText: '확인'
          })
        }
      } catch (e) {
        await this.$swal.fire({
          html: '<b>문제가 발생했습니다.</b><br/><br/>문제가 지속될 시 고객센터로 문의주세요.',
          confirmButtonText: '확인'
        })
      }
      this.closeDialog()
    },
  }
}
</script>
<style lang="scss" scoped>
  .v-toolbar {
    &__title {
      font-size: 1.188rem;
      font-weight: 600;
    }
  }
  .v-btn:not(.v-btn--round).v-size--default {
    height: 20px;
    min-width: 20px;
    padding: 0;
  }
  form {
    padding-top: 3.2vh !important;
    .row {
      display: flex;
      align-items: center;
    }
    .row, .toolbar {
      padding-left: 6vw !important;
      padding-right: 6vw !important;
    }
    .toolbar {
      margin-bottom: 1.9rem;
    }
    .head-title {
      h3 {
        font-size: 16px;
        font-weight: 600;
        line-height: 1.38;
        letter-spacing: normal;
        color: #333333;
        span {
          color: #e87167;
          font-weight: 800;
        }
      }
    }
    .must-mark {
      color: #00ADE5;
      font-size: 0.93rem;
      font-weight: 800;
    }
    .field-title {
      color: #727d8c;
      font-size: 0.93rem;
    }
    .description {
      line-height: 1.43;
      color: #727d8c;
      font-size: 0.875rem;
      margin-top: 1.1rem;
    }
    input {
      box-sizing: border-box;
    }
    button[type=submit] {
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-left-radius: 14px;
      border-bottom-right-radius: 14px;
      background-color: #d7e1ea;
      color: #00ADE5;
      font-size: 1.125rem;
      font-weight: 600;
      margin-top: 15px;
      letter-spacing: -0.66px;
      width: 100%;
      height: 3.75rem !important;
      &.active {
        color: #ffffff;
        box-shadow: 0 8px 16px 0 rgba(51, 51, 51, 0.12);
        background-color: #00ADE5 !important;
      }
    }
  }
</style>
